import { formats } from '../../common/format';
import util from '../../common/util';
import Range from '../../components/range.vue';
import Select from '../../components/select.vue';
import { mapState as rootMapState  } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { usePageStore } from '@/store'
import { mapAsyncData } from '../../plugins/asyncData';
import { initSearchBar } from './async-data';
import { fetchSuggestions, getListings, getDefaultSuggestion } from './api';
import * as TYPES from './_store/types';
import {
    handleSuggestion,
    getFirstSuggestion
} from '@/common/search-suggestion';

import { buildUrl } from '@/router/index.js';
export default {
    i18next: {
        ns: 'md-hero'
    },
    inject: ['newTabToListing'],
    props: [
        'needSearchCondition',
        'submitText',
        'placeholder',
        'configFilter',
        'autoSubmit',
        'agreementData',
        'searchButton'
    ],
    components: {
        Range,
        Select
    },
    data: function() {
        return {
            // searchData: [],
            showLocation: true,
            showStartPriceList: false,
            showEndPriceList: false,
            showSearchList: false,
            startPrice: '',
            endPrice: '',
            keyword: '',
            conditions: {},
            address: [],
            keyWordSuggestion: [],
            priceConfig: null,
            otherConfigs: [],
            filteredConfigs: []
        };
    },

    computed: {
        ...mapState({
            customizedCity: store => store.customizedCity,
            searchCharts: store => store.searchCharts,
            isExactSearch: store => store.isExactSearch,
            propertyConfigs: store => store.propertyConfigs,
            searchData: store => store.searchData,
            locationSuggestionUrl: store => store.locationSuggestionUrl,
            locationPlaceholder: store => store.locationPlaceholder
        }),
        ...rootMapState(usePageStore, {
            currencyRate: store => store.currencyRate,
            currencySymbol: store => store.currency.symbol,
            currencyAbbr: store => store.currency.abbr,
            baseCurrency: store => store.baseCurrency,
            page: store => store.page,
            siteId: store => store.siteId
        }),
        isCurCurrencyEqualBaseCurrency() {
            //  Determine whether the currently selected currency is equal to the base currency
            return this.currencyAbbr === this.baseCurrency;
        },
        hasConditions() {
            return this.priceConfig || this.otherConfigs.length;
        },
        // search input placeholder
        searchPlaceholder({ locationPlaceholder }) {
            if (this.placeholder) {
                return this.placeholder;
            }
            return (
                locationPlaceholder &&
                this.$t('md-hero.etc', { names: locationPlaceholder })
            );
        },
        otherSplitFilterConfigs() {
            return this.filteredConfigs.filter(
                item => !(item.inputType == 'inputBox' && item.name == 'price')
            );
        },
        priceSplitFilterConfigs() {
            return this.filteredConfigs.filter(
                item => item.inputType == 'inputBox' && item.name == 'price'
            );
        },
        searchButtonStyle() {
            if (this.searchButton) {
                return {
                    color: this.searchButton.textColor,
                    background: this.searchButton.backgroundColor
                }
            }
            return {}
        }
    },

    watch: {
        // keyword for the input box value
        // keyword() {
        //     this.keywordChange();
        // },
        // input  empty time ，  displayed to the user by default  suggestion list
        customizedCity: {
            immediate: true,
            handler: function() {
                if (!this.keyword) {
                    this.keyWordSuggestion = this.customizedCity;
                }
            }
        },
        searchData() {
            this.processData();
            this.calcConfigs();
        },
        configFilter: {
            deep: true,
            handler: function() {
                this.processData();
                this.calcConfigs();
            }
        },
        // siteId: {
        //     immediate: true,
        //     handler: async function () {
        //         if (!this.siteId) {
        //             return;
        //         }
        //         // this.initSearchBar();
        //         // this.processUrlParams();
        //         // this.getDefaultSuggestion();
        //     }
        // }
    },

    created() {
        this.processUrlParams();
        // if (!util.isClient) {
        // this.processUrlParams();
        this.calcConfigs();
        // }
        // this.suggestionAxios = util.throttledRequest();       
    },
    beforeMount() { 
        this.getDefaultSuggestion();
        this.suggestionCount = 0;
        this.keywordChange = util.debounce(this.handleSuggestion);
        if (util.isClient) {
            this.asyncDataPromise &&
                this.asyncDataPromise.then(() => {
                    this.processUrlParams();
                });
        }
    },
    methods: {
        ...mapActions({
            setCustomizedCity: TYPES.SET_CUSTOMIZED_CITY
        }),
        ...mapAsyncData({
            initSearchBar
        }),
        getDefaultSuggestion() {
            getDefaultSuggestion.call(this).then(res => {
                const { customizedCity } = res;
                this.setCustomizedCity(customizedCity);
            });
        },
        processSearchData(searchData) {
            this.processData();
        },
        processData() {
            const { confArr, locationConf } = this.filter(this.searchData);
            this.processPropertyConf(confArr);
            if (locationConf) {
                this.processLocationConf(locationConf);
            }
        },
        filter(searchData) {
            let confArr = [];
            let locationConf = null;
            const configFilter = this.configFilter || [
                'propertyType',
                'price',
                'baths',
                'beds'
            ];
            for (let search of searchData) {
                for (let o of search.conditions) {
                    if (
                        Array.isArray(configFilter) &&
                        configFilter.includes(o.name)
                    ) {
                        confArr.push(o);
                    }
                    // location
                    if (o.name.toLowerCase() === 'location') {
                        locationConf = o;
                    }
                }
            }
            if (!locationConf) {
                // this.showLocation = false;
            }
            return { confArr, locationConf };
        },
        processPropertyConf(confArr = []) {
            //  Need to deal with  input box  The maximum and minimum values of the

            confArr.forEach(conf => {
                const mask = conf.mask || {};
                if (conf.inputType === 'inputBox') {
                    const min = this.formatOptions(conf, 'min');
                    const max = this.formatOptions(conf, 'max');

                    conf.args = {
                        options: [min, max],
                        minTitle: mask.minTitle.replace(
                            '#global_name#',
                            conf.label
                        ),
                        maxTitle: mask.maxTitle.replace(
                            '#global_name#',
                            conf.label
                        ),
                        minLabel: mask.minTag,
                        maxLabel: mask.maxTag
                    };
                } else if (
                    conf.inputType === 'multiSelect' ||
                    conf.inputType === 'singleSelect'
                ) {
                    conf.options = [];
                    conf.args = [
                        { label: this.$t('common:any'), value: '' },
                        ...conf.options
                    ];
                }
            });
        },
        processLocationConf() {},
        formatOptions(conf, type) {
            return (
                ((conf = conf.mask) &&
                    (conf = conf.opt) &&
                    (conf = conf[type])
                        .split('\n')
                        .map(o => ({ label: o, value: o }))) ||
                []
            );
        },
        processUrlParams() {
            let params = this.pageLocation.query;
            let condition = {};
            if (params.condition) {
                try {
                    condition = JSON.parse(params.condition);
                } catch (e) {
                    console.error(e);
                }
            }
            if (condition.Location || condition.location) {
                const location = condition.Location || condition.location;
                let keywords = '';
                this.keywordType = Object.keys(location).join(':') || 'none';
                Object.values(location).forEach(k => {
                    keywords += k.join(':');
                });
                this.keyword = keywords;
                condition.Location && delete condition.Location;
                condition.location && delete condition.location;
            }
            this.propertyConfigs.forEach(config => {
                if (condition[config.name]) {
                    if (
                        config.inputType === 'inputBox' &&
                        config.name.toLowerCase() === 'price'
                    ) {
                        let prices = condition[config.name].split(',');
                        if (prices[0]) {
                            if (!this.isCurCurrencyEqualBaseCurrency) {
                                prices[0] = util.transferDollarToCurrency({
                                    price: prices[0] || '',
                                    isInt: true,
                                    currencyRate: this.currencyRate
                                });
                            }
                            this.setPriceRange('startPrice', +prices[0]);
                        }
                        if (prices[1]) {
                            if (!this.isCurCurrencyEqualBaseCurrency) {
                                prices[1] = util.transferDollarToCurrency({
                                    price: prices[1] || '',
                                    isInt: true,
                                    currencyRate: this.currencyRate
                                });
                            }
                            this.setPriceRange('endPrice', +prices[1]);
                        }
                    }
                    if (Array.isArray(condition[config.name])) {
                        condition[config.name] =
                            condition[config.name].join(','); 
                    }
                    this.conditions[config.name] = {
                        value: condition[config.name]
                    };
                }
            });
        },
        switchPrice() {
            let price1 = +this.startPrice.replace(/\D/g, '');
            let price2 = +this.endPrice.replace(/\D/g, '');
            if (this.startPrice && this.endPrice && price1 > price2) {
                let temp = this.startPrice;
                this.startPrice = this.endPrice;
                this.endPrice = temp;
            }
        },
        //  filter out the configured config
        calcConfigs() {
            let others = [];
            this.priceConfig = null;
            const configFilter = this.configFilter || [
                'propertyType',
                'purchaseType',
                'price',
                'baths',
                'beds'
            ];
            this.filteredConfigs = this.propertyConfigs.filter(config => {
                if (configFilter.indexOf(config.name) === -1) {
                    return false;
                }
                if (config.name.toLowerCase() === 'price') {
                    this.priceConfig = config; // todo,  Need to calculate according to the exchange rate price The corresponding currency
                } else {
                    others.push(config);
                }
                return true;
            });
            this.otherConfigs = others;
        },
        showPriceList: function(type, e) {
            this[type] = true;
            if (type === 'showStartPriceList') {
                this.showEndPriceList = false;
                e.outSideIgnore = this.closeStartPriceListPannel
            } else {
                this.showStartPriceList = false;
                e.outSideIgnore = this.closeEndPriceListPannel
            }
        },
        // suggestion list hidden
        hideSearchList() {
            this.setshowSearchList(false);
        },
        outsideClick() {
            this.hideSearchList()
        },
        changeDollarToNum(dollar) {
            return `${dollar}`.replace(/\D/g, '');
        },

        inputPrice(type, e) {
            let value = this.changeDollarToNum(e.target.value);
            this[type] = formats.currency({ value, noSpace: false, units: false, blank: '', currencySymbol: this.currencySymbol });
        },

        setPriceRange(type, price) {
            if (type === 'startPrice') {
                this.showStartPriceList = false;
            } else if (type === 'endPrice') {
                this.showEndPriceList = false;
            }

            this[type] = formats.currency({ value: price, noSpace: false, units: false, blank: '', currencySymbol: this.currencySymbol });
            this.switchPrice();
        },
        // toggle suggestion list  show and hide
        // input click callback for ， suggestion li click callbacks etc.
        setshowSearchList(bol, e) {
            if (e) {
                e.outSideIgnore = this.outsideClick;
            }
            this.showSearchList = bol; // suggestion list show
        },

        closeStartPriceListPannel() {
            this.showStartPriceList = false;
        },

        closeEndPriceListPannel() {
            this.showEndPriceList = false;
        },

        updateCondition(condition) {
            const { kee } = condition;
            this.conditions[kee] = Object.assign({}, condition);

            this.conditions = JSON.parse(JSON.stringify(this.conditions));
        },
        //  process selected suggestion There are the following situations
        // 1.  The user directly clicks suggestion list ， choose
        // 2.  user click enter key ， In case of exact search ， if exists suggestion list ， then select the first ， Otherwise, follow the fuzzy search process
        // 3.  user click  submit  search button ,  In case of exact search ， same   click enter key logic
        //  user click enter
        handleEnter() {
            if (this.isExactSearch && this.keyWordSuggestion.length > 0) {
                this.exactSearch();
            } else {
                this.fuzzySearch(this.keyword, 'none');
            }
        },
        //  user click search button
        //  deal with it first keyword and keyType field
        //  going to call  submitSearchHandler  deal with   Jump and other logic
        handleSearch() {
            this.keyword = this.keyword.trim();
            if (
                this.isExactSearch &&
                this.keyWordSuggestion.length > 0 &&
                this.keyword
            ) {
                this.exactSearch();
            }
            this.submitSearchHandler();
        },
        //  Handle Exact Search
        exactSearch() {
            const item = getFirstSuggestion(this.keyWordSuggestion, {
                type: this.keywordType,
                value: this.keyword
            });
            if (!item) {
                return; 
            }
            return this.selectSuggestion(item.value, item.type);
        },
        //  Handling fuzzy searches
        //  fuzzy search type for none，keyword Get the value entered by the user
        fuzzySearch(keyword, type) {
            return this.selectSuggestion(keyword, type);
        },

        submitSearchHandler() {
            if (this.submitDisabled) {
                return; 
            }
            const conditionParams = {};
            const paramsObj = {};
            if (this.keyword) {
                conditionParams.location = {
                    [this.keywordType || 'none']: [this.keyword]
                };
            }
            for (var k in this.conditions) {
                if (this.conditions[k].value) {
                    if (
                        k.toLowerCase() === 'propertytype' ||
                        k.toLowerCase() === 'purchasetype'
                    ) {
                        conditionParams[k.toLowerCase()] =
                            this.conditions[k].value.split(',');
                    } else {
                        conditionParams[k.toLowerCase()] =
                            this.conditions[k].value;
                    }
                }
            }
            // paramsObj.nopreset = '1';
            const inputPrice = this.propertyConfigs.find(
                item =>
                    item.inputType === 'inputBox' &&
                    item.name.toLowerCase() === 'price'
            );
            if (inputPrice && (this.startPrice || this.endPrice)) {
                if (!this.isCurCurrencyEqualBaseCurrency) {
                    let startPriceNum = this.changeDollarToNum(
                        this.startPrice
                    );
                    let curStartPriceDollar = util.transferPriceToDollar({
                        price: startPriceNum || '',
                        isInt: true,
                        currencyRate: this.currencyRate
                    });
                    let endPriceNum = this.changeDollarToNum(this.endPrice);
                    let curEndPriceDollar = util.transferPriceToDollar({
                        price: endPriceNum || '',
                        isInt: true,
                        currencyRate: this.currencyRate
                    });
                    conditionParams[
                        'price'
                    ] = `${curStartPriceDollar},${curEndPriceDollar}`;
                } else {
                    conditionParams['price'] = `${this.changeDollarToNum(
                        this.startPrice
                    )},${this.changeDollarToNum(this.endPrice)}`;
                }
            }
            paramsObj.condition = JSON.stringify(conditionParams);
            this.submitDisabled = true;
            setTimeout(() => {
                this.submitDisabled = false;
            }, 500);
            const state = window.history.state;
            if (this.newTabToListing) {
                window.open(buildUrl({ name: 'listing', query: paramsObj  }));
                return;
            }
            const saveParam = util.setQueryField(
                paramsObj,
                this.pageLocation.href
            );
            window.history.replaceState(
                state,
                (state && state.title) || '',
                saveParam
            );
            this.$EventBus.$emit(
                'change-url',
                buildUrl({ name: 'listing', query: paramsObj  }),
                this.$t('md-hero.allListing')
            );
        },
        //  monitor input box input event
        inputValue() {
            this.keywordType = 'none';
            this.keywordChange();
        },
        //  Obtain suggestion The data
        async getSuggestions(url, value) {
            let data = {
                key: value,
                propertyId: 0,
                siteId: this.siteId
                // t: Date.now()
            };
            return await fetchSuggestions.call(this, url, data);
        },
        // search input Callback when the input value changes , already debounce
        async handleSuggestion() {
            if (!this.keyword) {
                this.keyWordSuggestion = this.customizedCity;
                return;
            }
            this.keyWordSuggestion = handleSuggestion(
                await this.getSuggestions(
                    this.locationSuggestionUrl,
                    this.keyword
                ),
                Object.keys(this.searchCharts)
            );
        },
        //  deal with suggestion li  Click event callback
        async selectSuggestion(keyword, keywordType) {
            if (!keywordType) {
                return;
            }
            this.keywordType = keywordType;
            this.keyword = keyword;
            this.setshowSearchList(false);
            const ret = await this.handleStreetAddress(keywordType, keyword);
            if (!ret) {
                this.submitSearchHandler(); // search button click callback for
            }
        },
        async handleStreetAddress(type, keyword) {
            if (type === 'streetAddress') {
                try {
                    const res = await getListings.call(this, {
                        condition: JSON.stringify({
                            location: { [type]: [keyword] }
                        })
                    }, this.page);
                    const listings = res.listings;
                    if (Array.isArray(listings) && listings.length === 1) {
                        if (this.newTabToListing) {
                            window.open(listings[0].detailLink)
                            return true
                        }
                        this.$EventBus.$emit(
                            'change-url',
                            listings[0].detailLink,
                            ''
                        );
                        return true;
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        },
        changeOptions(list, conf) {
            conf.options = list;
            conf.args = [{ label: this.$t('common:any'), value: '' }];
            if (util.isArray(list)) {
                conf.args.push(...list);
            }
            this.$forceUpdate();
        }
    }
};
